import { languageService } from "../../../Language/language.service";
import { versionInfo } from "../../MainPage/VersionInfo";

export const fieldsToApplyMethod = [
  {
    path: "title",
    rule: "field",
    condition: (value) => typeof value === "string",
  },
  {
    path: "stateTitle",
    rule: "allProperties",
    condition: (value) => typeof value === "string",
  },
  {
    path: "sections[].fields[].labelValue",
    rule: "field",
    condition: (value) => typeof value === "string",
  },
];
export const MaintenanceSchema = {
  title: languageService("Work Order"),
  id: "MaintenanceSchema",
  stateTitle: {
    Add: languageService("Add New Work Order"),
    "app-edit": languageService("Edit Work Order"),
    "web-edit": languageService("Edit Work Order"),
    "not-new": languageService("Edit Work Order"),
  },
  sections: [
    {
      id: "MaintenanceFiles",
      fields: [],
      col: 2,
    },
    {
      id: "MaintenanceInfo",
      col: 4,
      fields: [
        {
          id: "mrNumber",
          type: "input",
          labelValue: languageService("MR#"),
          disabledStates: ["app-edit", "web-edit", "not-new"],
          hiddenStates: ["Add"],
        },
        {
          id: "lineId",
          type: "select",
          labelValue: languageService("Line"),
          selectOptions: [],
          required: true,
          disabledStates: ["app-edit", "web-edit", "not-new"],
          updateFieldOptionsOnCertainValue: [
            {
              targetSecId: "MaintenanceInfo",
              targetFieldId: "assetId",
              getFieldOptionsCallback: "getAssetsOnLineChange",
            },
          ],
        },
        {
          id: "assetId",
          type: "select",
          labelValue: languageService("Asset"),
          updatedSectionFieldsOnCertainValue: [
            { targetSecId: "MaintenanceLocInfo", getSectionFieldsCallback: "setMpMarkerSectionOnAssetChange" },
          ],
          selectOptions: [],
          required: true,
          disabledStates: ["app-edit", "web-edit", "not-new"],
        },
        {
          id: "maintenanceType",
          type: "select",
          labelValue: languageService("Maintenance Type"),
          selectOptions: [],
          disabledStates: ["not-new"],
        },

        {
          id: "priority",
          type: "select",
          labelValue: languageService("Priority"),
          selectOptions: [],
          required: true,
          disabledStates: ["not-new"],
        },
        {
          id: "description",
          type: "textarea",
          labelValue: languageService("Description"),
          disabledStates: ["not-new", "app-edit"],
        },
        {
          id: "dueDate",
          type: "date",
          labelValue: languageService("Plan Date"),
          disabledStates: ["not-new"],
        },

        {
          id: "voiceNotes",
          type: "textarea",
          labelValue: languageService("Information"),
          disabledStates: ["not-new", "app-edit"],
        },
      ],
    },

    {
      id: "MaintenanceLocInfo",
      col: 6,
      fields: [
        {
          id: "addHistorical", // required
          type: "checkbox", // required
          labelValue: languageService("Historical?"),
          showFieldsOnCertainValue: [{ values: [true], targetIds: ["closedDate"] }],
          col: 12,
          disabledStates: ["not-new", "app-edit", "web-edit"],
        },
        {
          id: "closedDate", // required
          type: "date", // required
          labelValue: languageService("Execution Date"),
          disabledStates: ["not-new", "app-edit", "web-edit"],
          col: 12,
          pastOnly: true,
        },
      ],
    },
    {
      id: "footerArea",
      col: 12,
      fields: [
        {
          id: "submitData",
          type: "button",
          labelValue: languageService("Save"),
          action: "submit",
          callback: "onSubmit",
          position: "footer",
          col: 6,
        },

        {
          id: "closeDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};

export const BridgeFields = {
  sectionID: "MaintenanceLocInfo",
  fields: [
    {
      id: "submittal",
      type: "input",
      labelValue: languageService("Submittal #"),
    },
    {
      id: "observation",
      type: "input",
      labelValue: languageService("Observation #"),
    },
    {
      id: "fdotId",
      type: "input",
      labelValue: languageService("FDOT ID#"),
      disabled: true,
      hide: true,
    },
    {
      id: "associated",
      type: "input",
      labelValue: languageService("Associated Track #"),
    },
    {
      id: "bridge",
      type: "input",
      labelValue: languageService("Bridge #"),
    },
    {
      id: "site",
      type: "input",
      labelValue: languageService("Site #"),
    },
  ],
};

export const WOGPSFields = [
  {
    sectionID: "MaintenanceLocInfo",
    pushIndex: (length) => length - length, // push at index 0,
    fields: [
      {
        id: "addGps", // required
        type: "checkbox", // required
        labelValue: `${languageService("Add")} ${languageService("GPS")}`,
        showFieldsOnCertainValue: [{ values: [true], targetIds: ["startLat", "startLon"] }],
        col: 12,
        disabledStates: ["not-new", "app-edit"],
      },
      {
        id: "startLat", // required
        type: "input", // required
        subType: "number",
        labelValue: languageService("GPS"),
        placeholderValue: languageService("Latitude"),
        required: true,
        col: 6,
        disabledStates: ["not-new", "app-edit"],
      },
      {
        id: "startLon", // required
        type: "input", // required
        subType: "number",
        labelValue: languageService(" "),
        placeholderValue: languageService("Longitude"),
        required: true,
        col: 6,
        disabledStates: ["not-new", "app-edit"],
      },
    ],
  },
];

export const TIMPSAfeField = [
  {
    sectionID: "MaintenanceInfo",
    pushIndex: (length) => length - 1, //push at second last index
    fields: [
      {
        id: "afeNumber",
        type: "input",
        labelValue: languageService("AFE Number"),
        disabledStates: ["not-new", "app-edit"],
      },
    ],
  },
];

export const TIMPSChargeCodeField = [
  {
    sectionID: "MaintenanceInfo",
    pushIndex: (length) => length - 1, //push at second last index
    fields: [
      {
        id: "chargeCode",
        type: "select",
        labelValue: languageService("Charge Code"),
        selectOptions: [],
        required: true,
        disabledStates: ["not-new", "app-edit"],
      },
    ],
  },
];

export const maintenanceSchemaMPFields = [
  {
    id: "startMp",
    type: "input",
    labelValue: languageService("Start"),
    disabled: true,
    required: true,
    disabledStates: ["app-edit", "not-new"],
  },
  {
    id: "endMp",
    type: "input",
    labelValue: languageService("End"),
    required: true,
    disabled: true,
    disabledStates: ["app-edit", "not-new"],
  },
];



// WEBPACK FOOTER //
// ./src/components/Maintenance/AddMaintenanceV2/workOrderSchema.js